import { QuizSubject } from '../interfaces/question.interface';

/** How an academic game card launches — maps to a MiniGameService entry. */
export type AcademicGameLaunch = 'symmetry' | 'matchup' | 'fractionline' | 'fractionhops' | 'fractiontrek' | 'zoomquest' | 'treasuregrid' | 'cubefill' | 'balanceit' | 'powerburst' | 'cuttingpizza' | 'vaultcracker';

export interface AcademicGame {
  id: string;
  name: { en: string; ar: string };
  sub: { en: string; ar: string };
  icon: string; // emoji
  launch: AcademicGameLaunch;
}

/**
 * The skill games available under each subject in the "Academic Skill
 * Games" category. Single source of truth: the subject picker counts
 * these, the games picker renders + launches them. Add a subject key
 * (or push another game) here to grow the shelf.
 */
export const ACADEMIC_GAMES: Partial<Record<QuizSubject, AcademicGame[]>> = {
  [QuizSubject.MATH]: [
    {
      id: 'symmetry',
      name: { en: 'Mirror Match', ar: 'مطابقة المرآة' },
      sub: { en: 'Lines of Symmetry', ar: 'خطوط التماثل' },
      icon: '🔷',
      launch: 'symmetry'
    },
    {
      id: 'matchup',
      name: { en: 'Star Match', ar: 'مطابقة النجوم' },
      sub: { en: 'Count, Add & Subtract', ar: 'عدّ وجمع وطرح' },
      icon: '🌟',
      launch: 'matchup'
    },
    {
      id: 'fractionline',
      name: { en: 'Fraction Blast', ar: 'انطلاق الكسور' },
      sub: { en: 'Fractions on a Number Line', ar: 'الكسور على خط الأعداد' },
      icon: '🚀',
      launch: 'fractionline'
    },
    {
      id: 'fractionhops',
      name: { en: 'Fraction Hops', ar: 'قفزات الكسور' },
      sub: { en: 'Multiply by Jumping', ar: 'اضرب بالقفز' },
      icon: '🐸',
      launch: 'fractionhops'
    },
    {
      id: 'fractiontrek',
      name: { en: 'Fraction Trek', ar: 'مسير الكسور' },
      sub: { en: 'Add & Subtract on a Number Line', ar: 'اجمع واطرح على خط الأعداد' },
      icon: '🧭',
      launch: 'fractiontrek'
    },
    {
      id: 'zoomquest',
      name: { en: 'Zoom Quest', ar: 'رحلة التكبير' },
      sub: { en: 'Find a Number by Place Value', ar: 'اعثر على رقم حسب القيمة المكانية' },
      icon: '🔍',
      launch: 'zoomquest'
    },
    {
      id: 'treasuregrid',
      name: { en: 'Treasure Grid', ar: 'شبكة الكنز' },
      sub: { en: 'Plot Points on a Grid', ar: 'حدد النقاط على الشبكة' },
      icon: '🗺️',
      launch: 'treasuregrid'
    },
    {
      id: 'cubefill',
      name: { en: 'Cube Fill', ar: 'ملء المكعبات' },
      sub: { en: 'Measure Cubic Volume', ar: 'قياس الحجم المكعب' },
      icon: '🧊',
      launch: 'cubefill'
    },
    {
      id: 'balanceit',
      name: { en: 'Balance It', ar: 'وازِن الميزان' },
      sub: { en: 'Metric Unit Conversion', ar: 'تحويل الوحدات المترية' },
      icon: '⚖️',
      launch: 'balanceit'
    },
    {
      id: 'powerburst',
      name: { en: 'Power Burst', ar: 'انفجار القوة' },
      sub: { en: 'Evaluate Exponents', ar: 'احسب الأسس' },
      icon: '💥',
      launch: 'powerburst'
    },
    {
      id: 'cuttingpizza',
      name: { en: 'Cutting Pizza', ar: 'تقطيع البيتزا' },
      sub: { en: 'Add & Subtract Fractions', ar: 'جمع وطرح الكسور' },
      icon: '🍕',
      launch: 'cuttingpizza'
    },
    {
      id: 'vaultcracker',
      name: { en: 'Vault Cracker', ar: 'خزنة النِّسَب' },
      sub: { en: 'Percent of a Quantity', ar: 'النسبة المئوية من كمية' },
      icon: '🔐',
      launch: 'vaultcracker'
    }
  ]
};
